import tw from 'twin.macro';

export const Container = tw.div`height[60px] bg-white px-4 py-3 shadow w-full flex items-center`;
export const Title = tw.div`font-bold ml-4`;
